/*
  Add here your own custom javascript codes
*/

console.log("Custom JS!");
const waitForElement = (selector) => {
  return new Promise((resolve) => {
    const element = document.querySelector(selector);
    if (element) {
      return resolve(element); 
    }

    const observer = new MutationObserver((mutationsList, observer) => {
      const foundElement = document.querySelector(selector);
      if (foundElement) {
        observer.disconnect(); 
        resolve(foundElement);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
};

const checkProductTitleist = document.querySelector('.template-product-titleist');
if(checkProductTitleist){
  waitForElement('.template-product-titleist .btn-atc.rfq-btn')
    .then((element) => {
      console.log('Element found:', element);
      var blockATC = document.querySelector('.template-product-titleist .product-block-atc');
      blockATC.insertAdjacentElement('beforebegin', element);
    })
    .catch((error) => {
      console.error('Error waiting for element:', error);
    });
}

// here the js for the different variants is not going right 
(function() {
  const sectionId = 'shopify-section-template--20325321375912__8f4f1b58-133b-491a-a7b2-8bf2e6fbc583';
  const section = document.getElementById(sectionId);

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function getSelectedOptions() {
    const selected = [];
    section.querySelectorAll('ul.product-options > li').forEach(li => {
      const checked = li.querySelector('input[type="radio"]:checked');
      if (checked) { selected.push(checked.value); return; }
      const sel = li.querySelector('select[name^="option-"]');
      if (sel && sel.value) { selected.push(sel.value); return; }
    });
    return selected;
  }

  function updatePrice(variant) {
    if (!variant) return;


    const priceSelectors = [
      '.price__current',
      '.price-item--regular',
      '.product__price',
      '.product-price__price',
      '[data-product-price]',
      '.price .amount',
      'span.price',
      '.price'
    ];

    let updated = false;
    for (const sel of priceSelectors) {
      const els = document.querySelectorAll(sel);
      if (els.length) {
        els.forEach(el => {
          el.innerHTML = formatMoney(variant.price);
        });
        console.log(` Price updated via "${sel}":`, formatMoney(variant.price));
        updated = true;
        break;
      }
    }

    if (!updated) {
      console.warn(' Still no price element found. Run the finder below.');
    }

    
    const variantInput = section.querySelector('input[name="id"], select[name="id"]');
    if (variantInput) {
      variantInput.value = variant.id;
      console.log(' Variant ID updated:', variant.id);
    }
  }

  function matchVariant() {
    const selectedOptions = getSelectedOptions();
    console.log('Selected:', selectedOptions);

    if (!window.__productVariants) {
      console.error('Variants not loaded yet');
      return;
    }

    const matched = window.__productVariants.find(v =>
      selectedOptions.every((opt, i) => v.options[i] === opt)
    );

    if (matched) {
      console.log(' Matched:', matched.title, '| Price:', formatMoney(matched.price));
      updatePrice(matched);
    } else {
      console.warn(' No variant matched for:', selectedOptions);
    }
  }

  fetch(window.location.pathname + '.js')
    .then(r => r.json())
    .then(product => {
      window.__productVariants = product.variants;
      console.log(' Variants loaded:', product.variants.length, 'variants');

      section.querySelectorAll('input[type="radio"]').forEach(input => {
        input.addEventListener('change', matchVariant);
      });

      section.querySelectorAll('select[name^="option-"]').forEach(sel => {
        sel.addEventListener('change', matchVariant);
      });

      matchVariant(); 
      console.log(' Listeners attached.');
    })
    .catch(e => console.error('Failed to load product JSON:', e));
})();


// (function() {
//   const IS_MOBILE     = window.innerWidth < 768;
//   const LIMIT_DESKTOP = 10; // shows 10 swatches + badge
//   const LIMIT_MOBILE  = 6;  // shows 5 swatches + badge
//   const LIMIT         = IS_MOBILE ? LIMIT_MOBILE : LIMIT_DESKTOP;
//   const BADGE_SIZE    = IS_MOBILE ? 26 : 32;

//   document.querySelectorAll('.swatch-overflow-badge').forEach(el => el.remove());

//   function applyLimit(ul, swatches, size) {
//     if (swatches.length <= LIMIT) return;

//     swatches.forEach((el, i) => el.style.display = i < LIMIT - 1 ? '' : 'none');

//     const hidden    = swatches.slice(LIMIT - 1);
//     const remaining = hidden.length;

//     const badge = document.createElement('li');
//     badge.className   = 'swatch-overflow-badge';
//     badge.textContent = '+' + remaining;
//     badge.style.cssText = `
//       display: inline-flex;
//       align-items: center;
//       justify-content: center;
//       width: ${size}px;
//       height: ${size}px;
//       border-radius: 50%;
//       background: #e5e5e5;
//       color: #333;
//       font-size: ${IS_MOBILE ? '8px' : '9px'};
//       font-weight: 600;
//       cursor: pointer;
//       margin: 2px;
//       flex-shrink: 0;
//     `;

//     ul.appendChild(badge);

//     let expanded = false;
//     badge.addEventListener('click', function(e) {
//       e.preventDefault();
//       e.stopPropagation();
//       expanded = !expanded;
//       hidden.forEach(el => el.style.display = expanded ? '' : 'none');
//       ul.appendChild(badge);
//       badge.textContent      = expanded ? 'less' : '+' + remaining;
//       badge.style.background = expanded ? '#333' : '#e5e5e5';
//       badge.style.color      = expanded ? '#fff' : '#333';
//     });
//   }



//   // --- Collection Page + Recommended Sectio
//   const allCardLists = document.querySelectorAll('ul.product-card-color-swatches');
//   if (allCardLists.length) {
//     allCardLists.forEach(ul => {
//       const swatches = Array.from(ul.querySelectorAll('li'));
//       applyLimit(ul, swatches, IS_MOBILE ? 22 : 26);
//     });
//     console.log(` Found ${allCardLists.length} card swatch lists (collection + recommended)`);
//   }

//   // --- Recommended section loads lazily
//   const observer = new MutationObserver(() => {
//     document.querySelectorAll('ul.product-card-color-swatches').forEach(ul => {
//       if (ul.dataset.limitApplied) return; 
//       const swatches = Array.from(ul.querySelectorAll('li'));
//       applyLimit(ul, swatches, IS_MOBILE ? 22 : 26);
//       ul.dataset.limitApplied = 'true'; 
//     });
//   });

//   observer.observe(document.body, { childList: true, subtree: true });

//   if (!detailUl && !allCardLists.length) {
//     console.warn(' No swatches found on this page');
//   }

// })();



// function initSwatches() {
//   const IS_MOBILE     = window.innerWidth < 768;
//   const LIMIT_DESKTOP = 10;
//   const LIMIT_MOBILE  = 6;
//   const LIMIT         = IS_MOBILE ? LIMIT_MOBILE : LIMIT_DESKTOP;
//   const BADGE_SIZE    = IS_MOBILE ? 26 : 32;

//   document.querySelectorAll('.swatch-overflow-badge').forEach(el => el.remove());

//   function applyLimit(ul, swatches, size) {
//     if (swatches.length <= LIMIT) return;

//     swatches.forEach((el, i) => el.style.display = i < LIMIT - 1 ? '' : 'none');

//     const hidden    = swatches.slice(LIMIT - 1);
//     const remaining = hidden.length;

//     const badge = document.createElement('li');
//     badge.className   = 'swatch-overflow-badge';
//     badge.textContent = '+' + remaining;
//     badge.style.cssText = `
//       display: inline-flex;
//       align-items: center;
//       justify-content: center;
//       width: ${size}px;
//       height: ${size}px;
//       border-radius: 50%;
//       background: #e5e5e5;
//       color: #333;
//       font-size: ${IS_MOBILE ? '8px' : '9px'};
//       font-weight: 600;
//       cursor: pointer;
//       margin: 2px;
//       flex-shrink: 0;
//     `;

//     ul.appendChild(badge);

//     let expanded = false;
//     badge.addEventListener('click', function(e) {
//       e.preventDefault();
//       e.stopPropagation();
//       expanded = !expanded;
//       hidden.forEach(el => el.style.display = expanded ? '' : 'none');
//       ul.appendChild(badge);
//       badge.textContent      = expanded ? 'less' : '+' + remaining;
//       badge.style.background = expanded ? '#333' : '#e5e5e5';
//       badge.style.color      = expanded ? '#fff' : '#333';
//     });
//   }

//   const allCardLists = document.querySelectorAll('ul.product-card-color-swatches');
//   if (allCardLists.length) {
//     allCardLists.forEach(ul => {
//       const swatches = Array.from(ul.querySelectorAll('li'));
//       applyLimit(ul, swatches, IS_MOBILE ? 22 : 26);
//       ul.dataset.limitApplied = 'true';
//     });
//   }
// }

// // Run on load
// initSwatches();

// // Run on resize
// window.addEventListener('resize', () => {
//   initSwatches();
// });

// // setInterval(() => {
// //   initSwatches();







  // (function () {
  //   function initSwatches() {
  //     const IS_MOBILE     = window.innerWidth < 768;
  //     const LIMIT_DESKTOP = 10;
  //     const LIMIT_MOBILE  = 6;
  //     const LIMIT         = IS_MOBILE ? LIMIT_MOBILE : LIMIT_DESKTOP;

  //     document.querySelectorAll('.swatch-overflow-badge').forEach(el => el.remove());

  //     function applyLimit(ul, swatches) {
  //       swatches.forEach(el => el.style.display = '');

  //       if (swatches.length <= LIMIT) {
  //         ul.dataset.limitApplied = 'true';
  //         return;
  //       }

  //       swatches.forEach((el, i) => {
  //         el.style.display = i < LIMIT - 1 ? '' : 'none';
  //       });

  //       const hidden    = swatches.slice(LIMIT - 1);
  //       const remaining = hidden.length;

  //       const badge = document.createElement('li');
  //       badge.className   = 'swatch-overflow-badge';
  //       badge.textContent = '+' + remaining;
  //       badge.style.cssText = `
  //         display: inline-flex;
  //         align-items: center;
  //         justify-content: center;
  //         width: ${IS_MOBILE ? 22 : 26}px;
  //         height: ${IS_MOBILE ? 22 : 26}px;
  //         border-radius: 50%;
  //         background: #e5e5e5;
  //         color: #333;
  //         font-size: ${IS_MOBILE ? '8px' : '9px'};
  //         font-weight: 600;
  //         cursor: pointer;
  //         margin: 2px;
  //         flex-shrink: 0;
  //       `;

  //       ul.appendChild(badge);

  //       let expanded = false;
  //       badge.addEventListener('click', function (e) {
  //         e.preventDefault();
  //         e.stopPropagation();
  //         expanded = !expanded;
  //         hidden.forEach(el => el.style.display = expanded ? '' : 'none');
  //         ul.appendChild(badge);
  //         badge.textContent      = expanded ? 'less' : '+' + remaining;
  //         badge.style.background = expanded ? '#333' : '#e5e5e5';
  //         badge.style.color      = expanded ? '#fff' : '#333';
  //       });

  //       ul.dataset.limitApplied = 'true';
  //     }

  //     document.querySelectorAll('ul.product-card-color-swatches').forEach(ul => {
  //       const swatches = Array.from(ul.querySelectorAll('li:not(.swatch-overflow-badge)'));
  //       applyLimit(ul, swatches);
  //     });
  //   }

   
  //   function runWhenReady() {
  //     if (document.readyState === 'loading') {
  //       document.addEventListener('DOMContentLoaded', function() {
  //         requestAnimationFrame(function() {
  //           requestAnimationFrame(initSwatches);
  //         });
  //       });
  //     } else {
       
  //       requestAnimationFrame(function() {
  //         requestAnimationFrame(initSwatches);
  //       });
  //     }
  //   }

  //   runWhenReady();

  //   let resizeTimer;
  //   window.addEventListener('resize', () => {
  //     clearTimeout(resizeTimer);
  //     resizeTimer = setTimeout(initSwatches, 1);
  //   });
  // })();


  // here to add the button class titleist full custom
  $(document).ready(function () {
  $('a[href*="titleist_custom_headwear_order_form"]').addClass('btn btn-primary btn-lg  w-100');
});